import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NavItemArgs } from './types';

export default function getWorkflowsNavItem(args: NavItemArgs) {
  const {
    id = '',
    myApprovalsCounter,
    pathname,
    t,
    urlParams,
    getUserAccessByComponent,
  } = args;
  const isTasksAvailable =
    getUserAccessByComponent(AccessComponentEnum.TasksManagement) !==
    AccessLevelEnum.LimitedRead;
  const isFormCategoriesAvailable =
    getUserAccessByComponent(AccessComponentEnum.FormCategoriesManagement) !==
    AccessLevelEnum.LimitedRead;
  const children: NavItem<unknown>[] = [];
  let to: string | undefined;
  if (isTasksAvailable) {
    to = APP_URLS.dashboard.tasks.index.getPathWithQuery();
    children.push(
      {
        id: 'tasks',
        title: t('tasks'),
        to: APP_URLS.dashboard.tasks.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.tasks.view.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.tasks.formView.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.tasks.reporting.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.tasks.interventions.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.tasks.edit.isTheSameUrlAs(pathname, {
              pathParts: { id },
            }) ||
            APP_URLS.dashboard.tasks.add.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.formTemplates.archived.isTheSameUrlAs(pathname)
          );
        },
        predictorFnVisible: () => isTasksAvailable,
      },
      {
        id: 'approvals',
        title: t('approvals'),
        to: APP_URLS.dashboard.tasks.approvals.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => !!myApprovalsCounter,
      },
      {
        id: 'all-form-templates',
        title: t('forms'),
        to: APP_URLS.dashboard.formTemplates.index.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnActive: () => {
          return (
            APP_URLS.dashboard.formTemplates.viewVersion.isTheSameUrlAs(
              pathname,
              {
                pathParts: { id, versionId: urlParams?.versionId },
              },
            ) ||
            APP_URLS.dashboard.formTemplates.viewLinkedTasks.isTheSameUrlAs(
              pathname,
              {
                pathParts: { id, versionId: urlParams?.versionId },
              },
            ) ||
            APP_URLS.dashboard.formTemplates.editVersion.isTheSameUrlAs(
              pathname,
              {
                pathParts: { id, versionId: urlParams?.versionId },
              },
            ) ||
            APP_URLS.dashboard.formTemplates.duplicate.isTheSameUrlAs(
              pathname,
              {
                pathParts: { id, versionId: urlParams?.versionId },
              },
            ) ||
            APP_URLS.dashboard.formTemplates.add.isTheSameUrlAs(pathname) ||
            APP_URLS.dashboard.formTemplates.archived.isTheSameUrlAs(pathname)
          );
        },
        predictorFnVisible: () => isTasksAvailable,
      },
    );
  }
  if (isFormCategoriesAvailable) {
    if (!to) {
      to = APP_URLS.dashboard.formTemplates.categories.getPathWithQuery();
    }
    children.push({
      id: 'form-template-categories',
      title: t('categories'),
      to: APP_URLS.dashboard.formTemplates.categories.getPathWithQuery(),
      type: NavItemTypeEnum.PrimarySub,
      end: true,
      predictorFnVisible: () => isFormCategoriesAvailable,
    });
  }
  return {
    id: 'workflows',
    title: t('workflows'),
    leftIcon: Icons.tasks,
    to,
    type: NavItemTypeEnum.Primary,
    predictorFnVisible: () => isTasksAvailable || isFormCategoriesAvailable,
    predictorFnActive: () => {
      return (
        APP_URLS.dashboard.tasks.index.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.tasks.approvals.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.tasks.add.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.tasks.edit.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.formTemplates.index.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.formTemplates.archived.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.formTemplates.categories.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.formTemplates.add.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.formTemplates.viewVersion.isTheSameUrlAs(pathname, {
          pathParts: { id, versionId: urlParams?.versionId },
        }) ||
        APP_URLS.dashboard.formTemplates.viewLinkedTasks.isTheSameUrlAs(
          pathname,
          {
            pathParts: { id, versionId: urlParams?.versionId },
          },
        ) ||
        APP_URLS.dashboard.formTemplates.editVersion.isTheSameUrlAs(pathname, {
          pathParts: { id, versionId: urlParams?.versionId },
        }) ||
        APP_URLS.dashboard.formTemplates.duplicate.isTheSameUrlAs(pathname, {
          pathParts: { id, versionId: urlParams?.versionId },
        })
      );
    },
    children,
  };
}
